import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { startLoading, endLoading } from '../../../../actions/loadingAction';
import ListLinkBox from '../../../../components/UI/ListLinkBox';
import * as actionsPicking from '../../../../actions/pickingAction';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS, ENUMS } from '../../../../utils/constants';
import { translate } from '../../../../utils/util';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';

const PickingFilter = (props) => {
    useEffect(() => {
        props.resetFilter();
        // eslint-disable-next-line
    }, []);

    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, { route: 'filter/supplier', icon: 'group', text: translate('expedition:picking.supplier') }];
        menuItems = [...menuItems, { route: 'filter/partnumber', icon: 'layers', text: translate('expedition:picking.partnumber') }];
        menuItems = [...menuItems, { route: 'filter/order', icon: 'business_center', text: translate('expedition:picking.order') }];
        menuItems = [...menuItems, { route: 'filter/cim', icon: 'filter_center_focus', text: translate('expedition:picking.cim') }];

        if (checkPermission(PERMISSIONS.Expedition.Picking.ManageOrder)) {
            menuItems = [...menuItems, {
                route: 'orders',
                icon: 'swap_vert',
                text: translate('expedition:picking.order-status.in-progress'),
                onClick: () => {
                    props.filter.status = [ENUMS.eOrderStatus.InProgress.value];
                    props.filter.orderType = ENUMS.eOrderType.Picking.value;
                    props.setFilterOrder(props.filter);
                }
            }];

            menuItems = [...menuItems, {
                icon: 'mdi mdi-clipboard-list-outline',
                text: 'Relatório',
                route: {
                    pathname: 'filter/report',
                    state: {
                        orderType: ENUMS.eOrderType.Picking.value
                    }
                }
            }];
        }

        menuItems = [...menuItems, {
            route: 'orders', icon: 'view_list', text: translate('expedition:picking.all'), onClick: () => {
                props.filter.orderType = ENUMS.eOrderType.Picking.value; props.setFilterOrder(props.filter);
            }
        }];

        return menuItems;
    }

    return (
        <div>
            <Breadcrumbs id="pickingFilter" title={{ icon: "mdi mdi-dolly", label: translate('expedition:picking.title') }}
                subtitles={[{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filter') }]} />
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox options={menu()} />
            </div>
        </div>
    );
}

export const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        filter: state.pickingReducer.filter
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
        resetFilter: () => {
            dispatch(actionsPicking.resetFilter());
        },
        setFilterOrder: (filter) => {
            dispatch(actionsPicking.setFilter(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingFilter)));
